import { SendWaiverLinkModal } from '@/views/Pages/Appointments/EventView/SendLinkModals/SendWaiverLinkModal';
import React, { PropsWithChildren } from 'react';

type MembershipAgreementModalProps = {
  onAgreementSend: () => void;
  customer: {
    guid: string;
    email: string;
    mobilePhone: string;
    id: number;
    name?: string;
  };
  dataSource: {
    what: string;
    membership_id: string;
  }[];
};

export const MembershipAgreementModal: React.FC<
  PropsWithChildren<MembershipAgreementModalProps>
> = ({ onAgreementSend, children, customer, dataSource }) => {
  return (
    <SendWaiverLinkModal
      title={
        'Send Membership Agreement to ' + (customer.name?.split(' ')[0] || '')
      }
      customer={customer}
      dataSource={dataSource}
      ErrorMessageComponent={React.memo(({ errors }) => {
        return <>{`${errors?.filter(e => !!e)[0] || ''} Please try again.`}</>;
      })}
      DescriptionComponent={() => {
        return children as any;
      }}
      onClose={() => onAgreementSend()}
      initiallyHideErrorButton={true}
    />
  );
};
